"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogEntryLevelEnum = exports.LogEntryToJSON = exports.LogEntryFromJSONTyped = exports.LogEntryFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function LogEntryFromJSON(json) {
    return LogEntryFromJSONTyped(json, false);
}
exports.LogEntryFromJSON = LogEntryFromJSON;
function LogEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdTime': (new Date(json['createdTime'])),
        'level': !runtime_1.exists(json, 'level') ? undefined : json['level'],
        'enrollmentId': !runtime_1.exists(json, 'enrollmentId') ? undefined : json['enrollmentId'],
        'payload': !runtime_1.exists(json, 'payload') ? undefined : _1.LogPayloadFromJSON(json['payload']),
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : json['metadata'],
    };
}
exports.LogEntryFromJSONTyped = LogEntryFromJSONTyped;
function LogEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdTime': (value.createdTime.toISOString()),
        'level': value.level,
        'enrollmentId': value.enrollmentId,
        'payload': _1.LogPayloadToJSON(value.payload),
        'metadata': value.metadata,
    };
}
exports.LogEntryToJSON = LogEntryToJSON;
/**
* @export
* @enum {string}
*/
var LogEntryLevelEnum;
(function (LogEntryLevelEnum) {
    LogEntryLevelEnum["INFO"] = "INFO";
    LogEntryLevelEnum["ERROR"] = "ERROR";
})(LogEntryLevelEnum = exports.LogEntryLevelEnum || (exports.LogEntryLevelEnum = {}));
//# sourceMappingURL=LogEntry.js.map